import React, { useEffect, useRef, useState } from "react";
import { Grid, Button, FormControl, Typography, Box } from "@mui/material";
import Layout from "../../../layout/Layout";
import {
  config,
  purchaseOrderAPI,
  purchaseOrderItemsAPI,
  projectMasterAPI,
  statusMasterAPI,
} from "../../../config";
import Pdf from "react-to-pdf";
import { TextField } from "@mui/material"; // ✅ Import MUI TextField
import axios from "axios";
import NotFound from "../../../components/NotFount";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
// import numberToWords from "number-to-words";
import moment from "moment";
import "moment/locale/en-in";
import { ToWords } from "to-words";
import { useReactToPrint } from "react-to-print";
import PoPdf from "./pdf/PoPdf";
import PurchaseOrderPDF from "./pdf/GeneratePdf";
import { PDFDownloadLink } from "@react-pdf/renderer";
import DOMPurify from "dompurify";
import PdfDocument from "./pdf/PoGeneratePdf";

const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      // can be used to override defaults for the selected locale
      name: "Rupee",
      plural: "Rupees",
      symbol: "₹",
      fractionalUnit: {
        name: "Paisa",
        plural: "Paise",
        symbol: "",
      },
    },
  },
});

const handleNumberToWOrdCurrency = (v) => {
  return toWords.convert(roundUpToInteger(v));
};

function roundUpToInteger(value) {
  return Number.parseFloat(value).toFixed(2);
}

function PurchaseOrderView() {
  const { poid } = useParams();
  const navigate = useNavigate();

  const [poDetails, setPODetails] = useState([]);
  const [paymentList, setPaymentList] = useState("");
  const [address, setAddress] = useState("");

  const [ClassificationData, setClassificationData] = useState("");
  let tempRef = useRef(false);

  // other all details
  useEffect(() => {
    if (tempRef.current === false) {
      const data = {
        intType: 2,
        intPOId: poid,
        intLimit: 1,
        intOffset: 0,
      };
      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = purchaseOrderAPI;

      axios(config)
        .then(function (response) {
          const poObj = response.data.result[1][0];
          setPODetails(poObj);
          console.log(poObj);
          const address = poObj?.address
            ? JSON.parse(poObj.address)
            : "";
          setAddress(address);
          fetchProjectDetails(poObj.project_id);
          if (poObj.purchase_classfication) {
            get_purchase_classification(poObj.purchase_classfication);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  const get_purchase_classification = (statusId) => {
    const data = {
      intType: 11,
      intStatusId: statusId,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = statusMasterAPI;

    axios(config)
      .then(function (response) {
        const result = response.data?.result;

        if (Array.isArray(result) && result.length > 0 && result[0]?.name) {
          setClassificationData(result[0].name);
        } else {
          setClassificationData("—");
          console.warn("Classification name not found in response:", result);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [projectDetails, setProjectDetails] = useState([]);

  // Fetching project details
  const fetchProjectDetails = (projectID) => {
    if (projectID === 0) {
      return;
    }

    const data = {
      intType: 2,
      intProjectID: projectID,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = projectMasterAPI;

    axios(config)
      .then((response) => {
        setProjectDetails(response.data.result[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // purchase order items
  useEffect(() => {
    if (tempRef.current === false) {
      const data = {
        intPONo: poid,
        intType: 2,
        // intLimit: 1,
        // intOffset: 0,
      };
      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = purchaseOrderItemsAPI;

      axios(config)
        .then(function (response) {
          setPaymentList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  const ref = React.createRef();
  const setPOStatus = (status) => {
    const data = {
      intType: 2,
      intStatus: status,
      intPOId: poid,
    };
    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = purchaseOrderAPI;

    axios(config)
      .then(function (response) { })
      .catch(function (error) {
        console.log(error);
      });
    return () => {
      tempRef.current = true;
    };
  };

  const twoDecimal = (x) => {
    // Convert to a float and format to two decimal places
    const num = Number.parseFloat(x).toFixed(2);

    // Split the integer and decimal parts
    const [integerPart, decimalPart] = num.split(".");

    // Format the integer part with a proper regex for Indian numbering system
    const formattedInteger = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    // Return the formatted value with the decimal part
    return `${formattedInteger}.${decimalPart}`;
  };

  function roundUpToInteger(value) {
    const roundedValue = Number.parseFloat(value);
    const num = roundedValue.toFixed(2);
    // Split the integer and decimal parts
    const [integerPart, decimalPart] = num.split(".");

    // Format the integer part with a proper regex for Indian numbering system
    const formattedInteger = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    // Return the formatted value with the decimal part
    return `${formattedInteger}.${decimalPart}`;
  }

  function calculateRoundingDifference(value) {
    return "0.00";
  }

  const renderHTML = (htmlString) => {
    return { __html: DOMPurify.sanitize(htmlString) };
  };

  const styles = {
    container: {
      display: "flex",
      // flexWrap: "wrap",
      gap: "8px",
      padding: "10px",
      justifyContent: "space-between", // Distribute space between items
    },
    section: {
      flex: "1 1 calc(100% - 20px)", // Full width on small screens
      padding: "5px",
      // border: "1px solid #ddd",
      borderRadius: "5px",
      // backgroundColor: "#f9f9f9",
      // minWidth: "300px", // Minimum width of each section
    },
    bold: {
      fontWeight: "bold",
      marginTop: "2px",
    },
    companyName: {
      fontSize: "0.85rem",
      fontWeight: "bold",
      color: "#0047AB",
    },
  };

  const logoMap = {
    "KG BUILD TECH": require("./../../../assets/images/Logo/Kg_Logo.png"),
    "KG FURN TECH": require("./../../../assets/images/Logo/Kg_furn_logo.png"),
    "KG CONSTRUCTIONS": require("./../../../assets/images/Logo/kg_const_logo.png"),
    "KG TRADE TECH": require("./../../../assets/images/Logo/kg_trade_logo.png"),
  };

  // Fetch the appropriate logo based on the company name
  const companyLogo = logoMap[poDetails.company_Name] || null; // Use null as a fallback if no match is found

  const poNo = poDetails?.po_no || ""; // fallback to empty string if undefined
  const match = poNo.match(/T(\d+)\//);
  const extractedNumber = match ? match[1] : "";
  return (
    <Layout>
      <Grid className="employee-form">
        <Grid item xs={12} lg={12} md={12}>
          <Grid container spacing={3} sx={{ alignItems: "center", mb: "20px" }}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <Typography className="page_title" textAlign="left">
                Purchase Order View
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">Purchase Order</Typography>
                <Typography color="text.primary">View</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
              style={{ textAlign: "right" }}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
                className="button_first"
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>
          <Grid container spacing={2} className={`bg-white`}>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              style={{ height: "100%" }}
              ref={ref}
              className="container print-container"
            >
              <div className="print-content">
                <Grid className="element-to-po">
                  <Grid className="page">
                    {/* Header Banner */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", marginBottom: "10px" }}>
                      <div style={{ width: "30%" }}>
                        <img
                          src={companyLogo}
                          alt="KG"
                          className="po-logo"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "60px",
                            objectFit: "contain"
                          }}
                        />
                      </div>
                      <div style={{
                        width: "70%",
                        backgroundColor: "#0056b3",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50px"
                      }}>
                        <h3 style={{ color: "#ffffff", fontSize: "24px", margin: 0, fontWeight: "bold" }}>
                          {poDetails.order_type == "1" ? "Purchase Order" : "Work Order"}
                        </h3>
                      </div>
                    </div>

                    {/* Metadata Header String */}
                    <div style={{ textAlign: "center", paddingBottom: "6px" }}>
                      <Typography
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {extractedNumber} {poDetails.vendor_name}{" "}
                        {moment(poDetails.po_date).format("DD-MM-YYYY")}{" "}
                        @ {poDetails.project_name}
                      </Typography>
                    </div>
                    <hr style={{ border: "0", borderTop: "1px solid #000", margin: "4px 0 10px 0" }} />

                    {/* Top Columns (Company Info & Order Info) */}
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
                      {/* Left Column: Company Info */}
                      <div style={{ width: "48%" }}>
                        <Typography
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#0056b3",
                            marginBottom: "6px"
                          }}
                        >
                          {poDetails.company_Name}
                        </Typography>
                        <Typography style={{ fontSize: "16px", lineHeight: "1.5" }}>
                          {poDetails ? poDetails.company_address : "Plot No 108, Perumal Koil Street, Alapakkam Porur"}
                        </Typography>
                        <Typography style={{ fontSize: "16px", lineHeight: "1.5" }}>
                          {poDetails ? `${poDetails.company_city} - ${poDetails.company_pincode}` : "Chennai - 600116"}
                        </Typography>
                        <Typography style={{ fontSize: "16px", lineHeight: "1.5" }}>
                          {poDetails ? `${poDetails.company_state}, India` : "Tamil Nadu, India"}
                        </Typography>
                        <Typography style={{ fontSize: "16px", color: "#0056b3", textDecoration: "underline", marginTop: "4px" }}>
                          <a href={poDetails?.company_website} target="_blank" rel="noreferrer" style={{ color: "inherit", textDecoration: "inherit" }}>
                            {poDetails ? poDetails.company_website : "https://kgbuildtech.com"}
                          </a>
                        </Typography>
                        {poDetails?.gst_no && (
                          <Typography style={{ fontSize: "16px", fontWeight: "bold", marginTop: "4px" }}>
                            GST NO: {poDetails.gst_no}
                          </Typography>
                        )}
                      </div>

                      {/* Right Column: Order details key-value block */}
                      <div style={{ width: "48%", display: "flex", flexDirection: "column", gap: "6px" }}>
                        <div style={{ display: "flex", fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold", minWidth: "170px" }}>{poDetails.order_type == "1" ? "PO Order No" : "WO Order No"}</span>
                          <span style={{ fontWeight: "bold", minWidth: "14px" }}>:</span>
                          <span>{poDetails.po_no}</span>
                        </div>
                        <div style={{ display: "flex", fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold", minWidth: "170px" }}>{poDetails.order_type == "1" ? "PO Classification" : "WO Classification"}</span>
                          <span style={{ fontWeight: "bold", minWidth: "14px" }}>:</span>
                          <span>{ClassificationData || "—"}</span>
                        </div>
                        <div style={{ display: "flex", fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold", minWidth: "170px" }}>Date</span>
                          <span style={{ fontWeight: "bold", minWidth: "14px" }}>:</span>
                          <span>{moment(poDetails.po_date).format("DD-MM-YYYY")}</span>
                        </div>
                        <div style={{ display: "flex", fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold", minWidth: "170px" }}>Site Engineer</span>
                          <span style={{ fontWeight: "bold", minWidth: "14px" }}>:</span>
                          <span style={{ color: "#0056b3", fontWeight: "bold" }}>{poDetails.site_eng_name}</span>
                        </div>
                        <div style={{ display: "flex", fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold", minWidth: "170px" }}>Supplier Ref</span>
                          <span style={{ fontWeight: "bold", minWidth: "14px" }}>:</span>
                          <span>{poDetails.quotation_no || "—"}</span>
                        </div>
                        <div style={{ display: "flex", fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold", minWidth: "170px" }}>Contact</span>
                          <span style={{ fontWeight: "bold", minWidth: "14px" }}>:</span>
                          <span style={{ color: "#0056b3", fontWeight: "bold" }}>{poDetails.site_eng_contact}</span>
                        </div>
                      </div>
                    </div>
                    <hr style={{ border: "0", borderTop: "1px solid #000", margin: "10px 0" }} />

                    {/* Address Section: Bill To & Place of Supply */}
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", marginBottom: "10px" }}>
                      {/* Bill To */}
                      <div style={{ width: "48%" }}>
                        <Typography style={{ fontWeight: "bold", fontSize: "17px", marginBottom: "6px" }}>
                          Bill To :
                        </Typography>
                        <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#0056b3" }}>
                          {poDetails.vendor_name} {poDetails.vendor_mobile ? `${poDetails.vendor_mobile}` : ""}
                        </Typography>
                        <Typography style={{ fontSize: "16px" }}>{poDetails.vendor_street}</Typography>
                        <Typography style={{ fontSize: "16px" }}>{poDetails.vendor_city}</Typography>
                        {poDetails.vendor_state?.toLowerCase() !== "tamilnadu" && (
                          <Typography style={{ fontSize: "16px" }}>
                            {poDetails.vendor_state}
                          </Typography>
                        )}
                        <Typography style={{ fontSize: "16px" }}>{poDetails.vendor_pincode}</Typography>
                        <Typography style={{ fontSize: "16px" }}>
                          <span style={{ fontWeight: "bold" }}>GSTIN :</span> {poDetails.vendor_gst || "—"}
                        </Typography>
                      </div>

                      {/* Place of Supply */}
                      <div style={{ width: "48%" }}>
                        <Typography style={{ fontWeight: "bold", fontSize: "17px", marginBottom: "6px" }}>
                          Place of Supply :
                        </Typography>
                        {address?.type === 1 ? (
                          <>
                            <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#0056b3" }}>
                              {projectDetails?.name}
                            </Typography>
                            <Typography style={{ fontSize: "16px" }}>{projectDetails?.project_address}</Typography>
                            <Typography style={{ fontSize: "16px" }}>{projectDetails?.city}</Typography>
                            {projectDetails?.state?.toLowerCase() !== "tamilnadu" && (
                              <Typography style={{ fontSize: "16px" }}>
                                {poDetails?.address_type === 2 ? poDetails.company_state : projectDetails?.state}
                              </Typography>
                            )}
                            <Typography style={{ fontSize: "16px" }}>{projectDetails?.pincode}</Typography>
                          </>
                        ) : (
                          <>
                            <Typography style={{ fontWeight: "bold", fontSize: "16px", color: "#0056b3" }}>
                              {projectDetails?.name || ""}
                            </Typography>
                            {address?.address?.split(",").map((line, index, arr) => (
                              <Typography key={index} style={{ fontSize: "16px" }}>
                                {line.trim()}{index < arr.length - 1 ? "," : ""}
                              </Typography>
                            ))}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Table of Goods / Items */}
                    <table className="po-content-2" style={{ borderCollapse: "collapse", border: "1px solid black" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th style={{ border: "1px solid black", width: "7%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>S.No</Typography>
                          </th>
                          <th style={{ border: "1px solid black", width: "40%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>Description of Goods</Typography>
                          </th>
                          <th style={{ border: "1px solid black", width: "8%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>Qty</Typography>
                          </th>
                          <th style={{ border: "1px solid black", width: "10%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>Amt(Rs)</Typography>
                          </th>
                          <th style={{ border: "1px solid black", width: "10%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>Discount</Typography>
                          </th>
                          <th style={{ border: "1px solid black", width: "10%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>GST</Typography>
                          </th>
                          <th style={{ border: "1px solid black", width: "15%", padding: "12px 8px" }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>Total Amt</Typography>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="pdf-tbl_body">
                        {paymentList.length > 0 ? (
                          paymentList.map((row, index) => (
                            <tr key={index} style={{ border: "1px solid black" }}>
                              <td className="text-center" style={{ border: "1px solid black", padding: "12px 8px", verticalAlign: "middle", textAlign: "center" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>{index + 1}</Typography>
                              </td>
                              <td style={{ border: "1px solid black", padding: "12px 8px", textAlign: "left", verticalAlign: "middle" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>
                                  {row.item_name}
                                </Typography>
                              </td>
                              <td style={{ border: "1px solid black", padding: "12px 8px", textAlign: "center", verticalAlign: "middle" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>
                                  {twoDecimal(row.quantity)} <br />({row.unit_name})
                                </Typography>
                              </td>
                              <td style={{ border: "1px solid black", padding: "12px 8px", textAlign: "right", verticalAlign: "middle" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>
                                  {twoDecimal(row.amount)}
                                </Typography>
                              </td>
                              <td style={{ border: "1px solid black", padding: "12px 8px", textAlign: "center", verticalAlign: "middle" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>
                                  {row.discount_type === "fixed"
                                    ? `Rs. ${twoDecimal(row.discount_value)}`
                                    : row.discount_type === "percentage"
                                      ? `${row.discount_value}%`
                                      : "—"}
                                </Typography>
                              </td>
                              <td style={{ border: "1px solid black", padding: "12px 8px", textAlign: "center", verticalAlign: "middle" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>
                                  {row.gst}%
                                </Typography>
                              </td>
                              <td style={{ border: "1px solid black", padding: "12px 8px", textAlign: "right", verticalAlign: "middle" }}>
                                <Typography sx={{ fontSize: "16.5px" }}>
                                  {twoDecimal(
                                    row.discount_type === "fixed"
                                      ? row.amount * row.quantity - row.discount_value
                                      : row.discount_type === "percentage"
                                        ? row.amount * row.quantity * (1 - row.discount_value / 100)
                                        : row.amount * row.quantity
                                  )}
                                </Typography>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "center", padding: "10px" }}>No items found</td>
                          </tr>
                        )}
                      </tbody>
                      <tbody className="tbody_col">
                        <tr style={{ border: "1px solid black" }}>
                          <td rowSpan={poDetails.total_igst > 0 ? 4 : 5} style={{ borderRight: "1px solid black", borderLeft: "1px solid black" }}></td>
                          <td rowSpan={poDetails.total_igst > 0 ? 4 : 5} style={{ borderRight: "1px solid black" }}></td>
                          <td rowSpan={poDetails.total_igst > 0 ? 4 : 5} style={{ borderRight: "1px solid black" }}></td>
                          <td colSpan={3} style={{ fontWeight: "bold", textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                            Total amount without GST
                          </td>
                          <td style={{ textAlign: "right", padding: "8px 12px", border: "1px solid black", fontWeight: "bold" }}>
                            {twoDecimal(poDetails.total_without_gst)}
                          </td>
                        </tr>
                        {poDetails.total_igst > 0 ? (
                          <tr style={{ border: "1px solid black" }}>
                            <td colSpan={3} style={{ fontWeight: "bold", textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                              IGST
                            </td>
                            <td style={{ textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                              {twoDecimal(poDetails.total_igst)}
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr style={{ border: "1px solid black" }}>
                              <td colSpan={3} style={{ fontWeight: "bold", textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                                CGST
                              </td>
                              <td style={{ textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                                {twoDecimal(poDetails.total_cgst)}
                              </td>
                            </tr>
                            <tr style={{ border: "1px solid black" }}>
                              <td colSpan={3} style={{ fontWeight: "bold", textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                                SGST
                              </td>
                              <td style={{ textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                                {twoDecimal(poDetails.total_sgst)}
                              </td>
                            </tr>
                          </>
                        )}
                        <tr style={{ border: "1px solid black" }}>
                          <td colSpan={3} style={{ fontWeight: "bold", textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                            Transport Charges (GST {poDetails.transport_gst || 0}%)
                          </td>
                          <td style={{ textAlign: "right", padding: "8px 12px", border: "1px solid black" }}>
                            {twoDecimal(poDetails.transport_charge || 0)}
                          </td>
                        </tr>
                        <tr style={{ border: "1px solid black" }}>
                          <td colSpan={3} style={{ fontWeight: "bold", textAlign: "right", padding: "8px 12px", border: "1px solid black", color: "#0056b3" }}>
                            Payable Amount
                          </td>
                          <td style={{ textAlign: "right", padding: "8px 12px", border: "1px solid black", fontWeight: "bold", color: "#0056b3" }}>
                            {roundUpToInteger(poDetails.total_with_gst)}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Terms & Conditions Box */}
                    <div style={{ marginTop: "18px", border: "1px solid #000", width: "100%" }}>
                      <div style={{ backgroundColor: "#f0f0f0", padding: "10px", textAlign: "center", borderBottom: "1px solid #000", fontWeight: "bold", fontSize: "17px" }}>
                        {poDetails.order_type == "1" ? "PO Terms & Condition(s):" : "WO Terms & Condition(s):"}
                      </div>
                      <div style={{ padding: "12px", textAlign: "center", fontSize: "16px" }}>
                        {poDetails.terms ? (
                          <div dangerouslySetInnerHTML={renderHTML(poDetails?.terms)} />
                        ) : (
                          "—"
                        )}
                      </div>
                    </div>

                    {/* Bank Details Box */}
                    <div style={{ marginTop: "18px", border: "1px solid #b0c4de", borderRadius: "8px", padding: "16px", width: "100%" }}>
                      <div style={{ color: "#0056b3", fontWeight: "bold", fontSize: "17px", marginBottom: "12px" }}>
                        Bank Details
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "16px" }}>
                        <div style={{ width: "48%", display: "flex", flexDirection: "column", gap: "8px" }}>
                          <div>
                            <span style={{ fontWeight: "bold" }}>Bank Name:</span> {poDetails.bank_name || "—"}
                          </div>
                          <div>
                            <span style={{ fontWeight: "bold" }}>Account Name:</span> {poDetails.account_name || "—"}
                          </div>
                          <div>
                            <span style={{ fontWeight: "bold" }}>Account Number:</span> {poDetails.account_no || "—"}
                          </div>
                        </div>
                        <div style={{ width: "48%", display: "flex", flexDirection: "column", gap: "8px" }}>
                          <div>
                            <span style={{ fontWeight: "bold" }}>Branch:</span> {poDetails.branch || "—"}
                          </div>
                          <div>
                            <span style={{ fontWeight: "bold" }}>IFSC Code:</span> {poDetails.ifsc_code || "—"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Signatures */}
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "50px", fontSize: "16px", fontWeight: "bold" }}>
                      <span>Prepared By</span>
                      <span>Verified By</span>
                      <span>Approved By QS</span>
                      <span>Approved By</span>
                      <span>Contractor/Vendor Signature</span>
                    </div>
                  </Grid>
                </Grid>
              </div>

              {/* Lower Buttons */}
              <div className="empty-space-20"></div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {poDetails.status == 91 && (
                  <div
                    style={{
                      position: "absolute",
                      right: "100px",
                      paddingBottom: "2rem",
                      marginTop: "3rem",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#2F58CD",
                        marginRight: "10px",
                        color: "white",
                      }}
                      className="button"
                      onClick={() => setPOStatus(91)}
                    >
                      Approve
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2F58CD", color: "white" }}
                      className="button"
                      onClick={() => setPOStatus(92)}
                    >
                      Deny
                    </Button>
                  </div>
                )}
              </div>
            </Grid>

            <Grid item xs={11}>
              <Box display={`flex`} justifyContent={`flex-end`} mr={2}>
                {/* <PurchaseOrderPDF
              poDetails={poDetails}
              projectDetails={projectDetails}
              paymentList={paymentList}
              companyLogo={companyLogo}
              classificationData={ClassificationData}
            />
             */}
                <PDFDownloadLink
                  document={
                    <PdfDocument
                      poDetails={poDetails}
                      projectDetails={projectDetails}
                      paymentList={paymentList}
                      companyLogo={companyLogo}
                      classificationData={ClassificationData}
                    />
                  }
                  fileName={`${extractedNumber} ${poDetails.vendor_name} ${moment(
                    poDetails.po_date,
                  ).format(
                    "DD-MM-YYYY",
                  )}@${poDetails.project_name}.pdf`.replace(/\s+/g, " ")}
                  style={{
                    textDecoration: "none",
                    padding: "6px 12px",
                    color: "#fff",
                    backgroundColor: "#2F58CD",
                    borderRadius: 4,
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  {({ loading }) =>
                    loading ? "Generating..." : "Generate PDF"
                  }
                </PDFDownloadLink>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}
export default PurchaseOrderView;
